import { render, staticRenderFns } from "./ElButtonList.vue?vue&type=template&id=52353850&scoped=true&"
import script from "./ElButtonList.vue?vue&type=script&lang=js&"
export * from "./ElButtonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52353850",
  null
  
)

export default component.exports